// Constants file for application-wide enums and constants
//
// 使用示例：
// import { PAY_TYPE, getPayTypeText, getPayTypeColor, PAY_TYPE_OPTIONS } from '@/utils/constants'
//
// // 在模板中使用
// <a-tag :color="getPayTypeColor(record.payType)">{{ getPayTypeText(record.payType) }}</a-tag>
//
// // 在下拉选择中使用
// <a-select v-model="form.payType" :options="PAY_TYPE_OPTIONS" />
//
// // 判断类型
// if (record.payType === PAY_TYPE.PAYOUT) { /* 代付逻辑 */ }
// if (record.payType === PAY_TYPE.PAYIN) { /* 代收逻辑 */ }

export const PLATFORM_TYPES = [
    { value: '', label: 'All' },
    { value: 'PHONEPE', label: 'PhonePe' },
    { value: 'IOBNET', label: 'IobNet' },
    { value: 'AIRTEL', label: 'Airtel' },
    { value: 'FREECHARGE', label: 'Freecharge' },
    { value: 'JIOFINANCE', label: 'JioFinance' },
    { value: 'MOBIKWIK', label: 'MobiKwik' },
    { value: 'INDUSPAY', label: 'IndusPay' },
    { value: 'ULTRACASH', label: 'UltraCash' },
    { value: 'PAYTM', label: 'Paytm' }
]

export const ACCOUNT_TYPES = [
    { value: '', label: 'All' },
    { value: '1', label: 'Personal' },
    { value: '2', label: 'Merchant' },
    { value: '3', label: 'Corporate' }
]

// Helper function to get label by value
export const getLabelByValue = (list, value) => {
    const item = list.find(item => item.value === value)
    return item ? item.label : ''
}

// paymentmethod
export const PAYMENT_METHODS = [
    { value: 'UPI', label: 'UPI' },
    { value: 'BANK', label: 'Bank' },
    { value: 'INR', label: 'INR' },
    { value: 'USDT', label: 'USDT' }
]

// 支付状态常量
export const PAYMENT_STATUS = [
    { value: '', label: '全部' },
    { value: '0', label: '支付中' },
    { value: '2', label: '已通过' },
    { value: '4', label: '已拒绝' },
    // { value: '6', label: '延迟通过' },
    { value: '3', label: '支付失败' },
    { value: '5', label: '支付超时' },
    { value: '9', label: '已关闭' },
    { value: '10', label: '待审核' },
    { value: '7', label: '已退款' },
    { value: '-1', label: '未知' }
]

// 支付状态映射（用于获取状态文本和颜色）
export const PAYMENT_STATUS_MAP = {
    '0': { text: '支付中', color: 'orange' },
    '2': { text: '已通过', color: 'green' },
    '6': { text: '延迟通过', color: 'blue' },
    '4': { text: '已拒绝', color: '#e2214e' },
    '3': { text: '支付失败', color: 'volcano' },
    '5': { text: '支付超时', color: '#f6a572' },
    '9': { text: '已关闭', color: '#e6e6e6' },
    '10': { text: '待审核', color: '#f1405d' },
    '-1': { text: '未知', color: '#666' },
    '7': { text: '已退款', color: 'rgb(35 124 40)' }
}

// 获取支付状态文本
export const getPaymentStatusText = (status) => {
    // 将状态转换为字符串进行查找
    const statusKey = String(status)
    return PAYMENT_STATUS_MAP[statusKey]?.text || '--'
}

// 获取支付状态颜色
export const getPaymentStatusColor = (status) => {
    // 将状态转换为字符串进行查找
    const statusKey = String(status)
    return PAYMENT_STATUS_MAP[statusKey]?.color || 'default'
}

// 导出系统类型常量
export const EXPORT_SYS_TYPE = {
    'MGR': '运营平台',
    'MCH': '商户中心'
}

// 导出业务类型常量
export const EXPORT_BIZ_TYPE = {
    'PAY_IN': '代收',
    'PAY_OUT': '代付'
}

// 导出状态常量
export const EXPORT_STATUS = {
    '0': '待处理',
    '1': '处理成功',
    '2': '处理失败'
}

// 导出状态映射（用于获取状态文本和颜色）
export const EXPORT_STATUS_MAP = {
    '0': { text: '待处理', color: 'orange' },
    '1': { text: '处理成功', color: 'green' },
    '2': { text: '处理失败', color: 'volcano' }
}

// 导出系统类型选项（用于下拉选择）
export const EXPORT_SYS_TYPE_OPTIONS = [
    { value: '', label: '全部' },
    { value: 'MGR', label: '运营平台' },
    { value: 'MCH', label: '商户中心' }
]

// 导出业务类型选项（用于下拉选择）
export const EXPORT_BIZ_TYPE_OPTIONS = [
    { value: '', label: '全部' },
    { value: 'PAY_IN', label: '代收' },
    { value: 'PAY_OUT', label: '代付' }
]

// 导出状态选项（用于下拉选择）
export const EXPORT_STATUS_OPTIONS = [
    { value: '', label: '全部' },
    { value: '0', label: '待处理' },
    { value: '1', label: '处理成功' },
    { value: '2', label: '处理失败' }
]

// 获取导出系统类型文本
export const getExportSysTypeText = (sysType) => {
    return EXPORT_SYS_TYPE[sysType] || sysType
}

// 获取导出业务类型文本
export const getExportBizTypeText = (bizType) => {
    return EXPORT_BIZ_TYPE[bizType] || bizType
}

// 获取导出状态文本
export const getExportStatusText = (status) => {
    const statusKey = String(status)
    return EXPORT_STATUS_MAP[statusKey]?.text || '未知'
}

// 获取导出状态颜色
export const getExportStatusColor = (status) => {
    const statusKey = String(status)
    return EXPORT_STATUS_MAP[statusKey]?.color || 'default'
}

// 支付通道类型常量（数字值映射）
export const PAY_TYPE = {
    PAYOUT: 0, // 代付
    PAYIN: 1 // 代收
}

// 支付通道类型映射（用于获取类型文本和颜色）
export const PAY_TYPE_MAP = {
    [PAY_TYPE.PAYOUT]: { text: '代付', englishText: 'Payout', color: 'blue' },
    [PAY_TYPE.PAYIN]: { text: '代收', englishText: 'Payin', color: 'green' }
}

// 支付通道类型选项（用于下拉选择）
export const PAY_TYPE_OPTIONS = [
    { value: '', label: '全部' },
    { value: PAY_TYPE.PAYOUT, label: '代付' },
    { value: PAY_TYPE.PAYIN, label: '代收' }
]

// 获取支付类型文本
export const getPayTypeText = (payType) => {
    const typeKey = Number(payType)
    return PAY_TYPE_MAP[typeKey]?.text || '--'
}

// 获取支付类型英文文本
export const getPayTypeEnglishText = (payType) => {
    const typeKey = Number(payType)
    return PAY_TYPE_MAP[typeKey]?.englishText || '--'
}

// 获取支付类型颜色
export const getPayTypeColor = (payType) => {
    const typeKey = Number(payType)
    return PAY_TYPE_MAP[typeKey]?.color || 'default'
}
